module.exports = __webpack_public_path__ + "static/media/shells_world_map_1024.85e85fe5.png";